import React from 'react';
import RightProductArrow from "../../images/RightProductArrow";
import { ReactComponent as NfdCombineAdaptive } from "./NfdCombineAdaptive.svg";
import { ReactComponent as NfdPlatformAdaptive } from "./NfdPlatformAdaptive.svg";
import { ReactComponent as NfdTradingAdaptive } from "./NfdTradingAdaptive.svg";

interface HeaderProductsItemProps {
	title: string;
	onPress: () => void;
	type: "Combine" | "Platform" | "Trading" | "Something";
	mode: 'dark' | 'light';
}

const HeaderProductsItem = (props: HeaderProductsItemProps) => {
	return (
		<button
			className="headerProductsItemMobile"
			onClick={props.onPress}
		>
			<div className="platformImage">
				{
					props.type === "Combine" ? (
						<NfdCombineAdaptive />
					) : props.type === "Platform" ? (
						<NfdPlatformAdaptive />
					) : props.type === "Trading" ? (
						<NfdTradingAdaptive />
					) : (
						<img
							className={`iconItem ${props.type}`}
							src={`${process.env.PUBLIC_URL}/assets/images/Nfd${
									props.type === 'Something' ?
										props.mode === 'dark' ?
											'SomethingLight'
											:
											'SomethingDark'
										:
										props.type
							}.svg`}
							alt={`Image ${props.type}`}
						/>
					)
				}
			</div>
			<div className="infoWrap">
				<div className={`info ${props.mode}`}>
					<h3>{props.title}</h3>
				</div>
				<RightProductArrow
					color={
						props.mode === 'dark' ? "#fff" : "#080015"
					}
				/>
			</div>
		</button>
	);
};

export default HeaderProductsItem;